module.exports = __webpack_public_path__ + "static/media/myCheckScreen.82a1704b.png";